import { AxiosResponse } from 'axios';

import { SustainableActionsI } from '../../declarations/interfaces/sustainableAction';
import { get } from '../api';

export const getSustainableActionList = async (): Promise<AxiosResponse<SustainableActionsI>> =>
  await get(`/cfc/sustainability/getSustainability/localization`);
